import { notification } from "antd";

export default (errors) => {
  errors ? errors.map((error) =>
    notification["error"]({
      message: error.message,
      description: error.stack,
    })
  ) : notification["error"]({
    message: 'An error occurred!',
  });
};
